import _ from "lodash";
import * as R from "ramda";
import { SERVICES } from "@app/constants";
import { currentUser } from "../auth/selectors";

export const treatmentsArray = (state) => (state.entities.treatments ? Object.values(state.entities.treatments) : []);
export const students = (state) => state.entities.students;
export const therapists = (state) => state.entities.therapists;

export const treatmentsByStudentId = (state) => (studentId) => {
  const treatments = R.path(["entities", "treatments"], state);
  const obj = _.values(treatments || {}).filter((treatment) => treatment.student === studentId);
  return obj;
};

export const isInSession = (state) => state.treatment.isInSession;

export const getTreatment = (state) => state.treatment.data;

export const getTreatmentV3 = (state) => state.treatmentServerDataSlice?.serverData;

export const isDyslexiaUser = state => {
  const user = currentUser(state);
  return user?.services?.includes(SERVICES.DYSLEXIA.id);
};

export const getCertificationMap = (state) => {
  let treatment = getTreatment(state);
  if (!treatment) {
    treatment = getTreatmentV3(state);
  }
  return treatment
    ? treatment?.cert_area_of_need?.map(area => (
      { id: area.area_of_need.id,
        txt: area.area_of_need.certification_label,
      }
    )) : null;
};
